export enum RelationshipType {
    Spouse = 1,
    Child = 2,
    DomesticPartner = 3,
    OtherLegalDependent = 4
}